import * as THREE from "three";
// import {Interaction} from "three.interaction";

import {setSliderGrafics} from "./setSliderGrafics";
import * as INIT from "./panorama";
import * as COCKPIT from "./cockpit";

//NEW Imports
import {aircraftConfig, settings} from '../../config';
import {procedureTeacher} from "../ProcedureTeacher";
import {TextureSwitcher} from "./TextureSwitcher";

import Vue from 'vue';
import {registerFun} from "./fun";
import {createOuterSphere} from "./panorama";
import {glbLoader} from "../three/glbloader";
import {tweenFOV} from "@/modules/three/fovtween";

export const LATEventBus = new Vue()

let activeLAT = null;

export function getLAT(){
    return activeLAT;
}

export function initLAT(aircraft){

    Vue.$log.debug('init new LAT for '+aircraft.aircraftName+'. active: ', window.activeLAT)
    if(window.activeLAT){
        window.activeLAT.destroyLAT();
    }

    window.activeLAT = activeLAT = new LAT(aircraft);
    return getLAT();
}

class LAT {

    constructor(aircraft) {

        this.logging_key = `lat_${(new Date().getTime())}`

        aircraftConfig.selectAircraft(aircraft);
        //CONSTANTEN
        this.settings = settings;
        //INTERACTION
        this.screen = false;
        //MAIN Data
        this.scene = ""
        this.renderer = ""
        this.viewer = ""
        this.camera = ""
        this.meshTransparencyValue = 0;
        this.cockpit = COCKPIT.initEmptyCockpit()
        this.mouseVector = new THREE.Vector3(0,0,0);

        this.fov = {
            value: 22,
            register: ["sliderright"]
        }
    }

    /**
     * Convert 2D Screen Window Coordinate to a 3D representation from the camera
     * @param x
     * @param y
     * @returns {Vector3}
     */
    convert2Dto3Dcoordinate(x, y){
        let vector = new THREE.Vector3();
        vector.set((x / window.innerWidth) * 2 - 1, -(y / window.innerHeight) * 2 + 1,0);
        vector.unproject(this.camera);
        return vector;
    }

    log(...objects){
        Vue.$log.debug(this.logging_key, ...objects)
    }

    /**
     * Get the point where center of screen is "looking at" the panorama sphere
     * @returns {Vector3}
     */
    getPointOnSphere(){
        const raycaster = new THREE.Raycaster();
        const vector = new THREE.Vector3( 0, 0, 0 ); // instead of event.client.x and event.client.y
        const direction = new THREE.Vector3( 0, 0, -1 ).transformDirection( this.camera.matrixWorld );
        raycaster.set( vector, direction );
        const intersects = raycaster.intersectObject(this.panorama, true);

        if ( intersects.length > 0 ) {

            const point = intersects[ 0 ].point.clone();
            const converter = new THREE.Vector3( -1, 1, 1 );
            const world = this.panorama.getWorldPosition( new THREE.Vector3() );
            point.sub( world ).multiply( converter );

            // const message = `${point.x.toFixed(2)}, ${point.y.toFixed(2)}, ${point.z.toFixed(2)}`;
            // console.log(message)

            return point;
        }

        return new THREE.Vector3(0,0,0);
    }

    /**
     * Create a timed tween from current lookAt position to the desired object
     * @param object3D
     * @param inverted
     * @param overrideDuration
     */
    lookAtObject(object3D, inverted, overrideDuration){
        let duration = overrideDuration;
        const position = (object3D.position ? object3D.position : object3D).clone()
        position.setX(position.x * (inverted?-1:1))

        if(duration === undefined){
            const lookAtSphere = this.getPointOnSphere();
            const distance = position.distanceTo(lookAtSphere);
            duration = Math.min(settings.TWEEN_MAX_TIME, Math.max(settings.TWEEN_MIN_TIME, distance * 0.2));
        }

        // see tween curves https://sole.github.io/tween.js/examples/03_graphs.html
        this.viewer.tweenControlCenter(position, duration, TWEEN.Easing.Sinusoidal.InOut);

        return duration;
    }

    lookAtStartPoint(){
        this.lookAtObject(new THREE.Vector3(...settings.DEFAULT_LOOKAT_POS));
    }

    async initPanorama(element, aircraftRoom) {

        this.log('init panorama', element, aircraftRoom)

        this.parentScene = new THREE.Scene();
        this.parentScene.name = 'LAT parent scene'

        // let skyboxConfig = aircraftConfig.getConfig().skybox;
        // if(skyboxConfig){
        //     skyboxConfig = Object.assign({}, skyboxConfig, {image : aircraftConfig.getAsset(skyboxConfig.image)});
        // }

        this.scene = this.panorama = INIT.scene(aircraftRoom.loadedTextures.sphere, undefined, undefined ); //get the Panolens Panorama Mesh

        this.log('init scene done')

        this.renderer = INIT.renderer();
        this.viewer = INIT.viewer(element, this.renderer, {scene: this.parentScene}); //Set the Three Viewer
        this.camera = this.viewer.getCamera(); //Generate short link for camera
        // const interaction = new Interaction(
        //     this.renderer,
        //     this.scene,
        //     this.camera
        // );

        this.textureSwitcher = new TextureSwitcher(this.panorama).registerFromConfig();

        // if(aircraftConfig.getConfig().panels){
        //     this.cockpit.panels = await COCKPIT.load(aircraftConfig.selected, this.cockpit.materials);
        // }

         // Add clickable panels
        // await this.addPanelsToScene();

        // Let there be light
        this.scene.add(new THREE.AmbientLight(0xffffff, 1));

        const lightsource = new THREE.PointLight(0xffffff, 1, -1, -1);
        lightsource.position.set(-1000, 4500, 0);
        this.scene.add(lightsource);

        // add debug rotating cube
        // const cube = createRotatingCube(-1000, -150, 0, this.viewer);
        // this.scene.add(cube);
        // procedureTeacher.setLineTarget(cube);

        // listen for updates
        this.viewer.addUpdateCallback(this.updateReceived);

        //initiate Panorama Loader
        this.viewer.add(this.scene);

        registerFun(aircraftConfig.getConfig());

        LATEventBus.$on('slider-change', payload => this.onSliderChange(payload))
    }

    destroyLAT(){
        this.log('destroy lat.. ')
        this.viewer.removeUpdateCallback(this.updateReceived);
        setTimeout(()=>{
            this.panorama.dispose();
            this.viewer.dispose();
        }, 100);
        LATEventBus.$off('slider-change', this.onSliderChange)
    }

    replaceSkybox(skyboxConfig){
        skyboxConfig = skyboxConfig ? skyboxConfig : aircraftConfig.getConfig().skybox;
        if(!this.panorama.outerSphere){
            throw new Error('Pano must be loaded with skybox to replace texture');
        }
        const asset = aircraftConfig.getAsset(skyboxConfig.image)
        skyboxConfig.image = asset ? asset : skyboxConfig.image;
        createOuterSphere(skyboxConfig, this.panorama);
    }

    updateReceived = () => {
        procedureTeacher.drawLine();
    }

    async addPanelsToScene(){
        let itemMesh = await glbLoader(aircraftConfig.getMeshPath('item'));
        itemMesh.material = this.cockpit.materials.items;

        let mesh, el;

        this.log('init panels', this.cockpit.panels)

        for (let panel in this.cockpit.panels) {
            this.scene.add(this.cockpit.panels[panel].meshBorder);
            this.scene.add(this.cockpit.panels[panel].meshFull);
            this.scene.add(this.cockpit.panels[panel].meshTitle);
            for (let item in this.cockpit.panels[panel].items) {
                el = this.cockpit.panels[panel].items[item];
                mesh = itemMesh.clone();
                mesh.position.set(
                    el.main.positionX,
                    el.main.positionY,
                    el.main.positionZ
                );
                mesh.scale.set(el.main.scaleX, el.main.scaleY, el.main.scaleZ);
                mesh.rotation.set(
                    el.main.rotationX,
                    el.main.rotationY,
                    el.main.rotationZ
                );
                this.cockpit.panels[panel].items[item].mesh = mesh;
                this.scene.add(this.cockpit.panels[panel].items[item].mesh);
            }
        }

        aircraftConfig.getConfig().screens.forEach((screenData, idx) => {
            mesh = itemMesh.clone();
            mesh.position.set(...screenData.position);
            mesh.scale.set(...screenData.scale);
            mesh.rotation.set(...screenData.rotation);
            mesh.name = 'screen_'+idx
            mesh.material.copy(this.cockpit.materials.screen);
            this.scene.add(mesh)
            this.cockpit.screens.push(mesh);
        })
    }

    sliderToFov(sliderValue) {
        return Math.round(
            this.settings._FOV_MAX -
            (sliderValue * (this.settings._FOV_MAX - this.settings._FOV_MIN)) /
            this.settings._SLIDER_RES
        );
    }

    fovToSlider(fovValue) {
        return Math.round(
            this.settings._SLIDER_RES -
            ((fovValue - this.settings._FOV_MIN) * this.settings._SLIDER_RES) /
            (this.settings._FOV_MAX - this.settings._FOV_MIN)
        );
    }

    sliderToScale(value, valueMax, targetStart, targetEnd) {
        valueMax = valueMax === undefined ? this.settings._SLIDER_RES : valueMax
        targetStart = targetStart === undefined ? 0 : targetStart
        targetEnd = targetEnd === undefined ? 1 : targetEnd
        return (value / valueMax) * (targetEnd - targetStart) + targetStart;
    }

    valueToScale(start, end, value) {
        return Math.round(
            start + (value / this.settings._SLIDER_RES) * (end - start)
        );
    }

    setPanelBorder(value) {
        if (value <= 100) {
            let calculateValue = this.sliderToScale(value, 100, 0, 1);
            this.cockpit.materials.panelsBorder.opacity = calculateValue;
            return false;
        }
        if (value <= 200) {
            this.cockpit.materials.panelsBorder.opacity = 1;
            return false;
        }
        if (value <= 300) {
            let calculateValue = 1 - this.sliderToScale(value - 200, 100, 0, 1);
            this.cockpit.materials.panelsBorder.opacity = calculateValue;
            return false;
        }
        if (value > 300) {
            this.cockpit.materials.panelsBorder.opacity = 0;
        }
    }

    onSliderChange(payload){
        const {actionType, value} = payload;
        if(actionType === 'mesh'){
            this.setPanelBorder(value);
            this.setPanelFull(value);
            this.setItem(value);
            this.setNames(value);
        }
        if(actionType === 'fov'){
            this.fov.value = this.sliderToFov(value)
            tweenFOV(this.camera, this.fov.value, payload.animationTime ? payload.animationTime : 700)
        }
        if(actionType === 'poi'){
            procedureTeacher.setHelplineVisibility(value)
        }
    }

    setPanelFull(value) {
        this.log('setPanelFull', value);
        if (value <= 200) {
            this.cockpit.materials.panelsFull.opacity = 0;
            return false;
        }
        if (value <= 250) {
            let calculateValue = this.sliderToScale(value - 200, 50, 0, 1);
            this.cockpit.materials.panelsFull.opacity = calculateValue;
            return false;
        }
        if (value <= 300) {
            this.cockpit.materials.panelsFull.opacity = 1;
            return false;
        }
        if (value <= 350) {
            let calculateValue = 1 - this.sliderToScale(value - 300, 50, 0, 1);
            this.cockpit.materials.panelsFull.opacity = calculateValue;
            return false;
        }
        if (value > 350) {
            this.cockpit.materials.panelsFull.opacity = 0;
        }
    }

    setItem(value) {
        if (value <= 200) {
            this.cockpit.materials.items.opacity = 0;
            return false;
        }
        if (value <= 250) {
            let calculateValue = this.sliderToScale(value - 200, 50, 0, 1);
            this.cockpit.materials.items.opacity = calculateValue;
            return false;
        }
        if (value <= 300) {
            this.cockpit.materials.items.opacity = 1;
            return false;
        }
        if (value <= 350) {
            let calculateValue = 1 - this.sliderToScale(value - 300, 50, 0, 0.2);
            this.cockpit.materials.items.opacity = calculateValue;
            return false;
        }
        if (value <= 450) {
            this.cockpit.materials.items.opacity = 0.8;
            return false;
        }
        if (value <= 500) {
            let calculateValue = 1 - this.sliderToScale(value - 450, 50, 0.2, 1);
            this.cockpit.materials.items.opacity = calculateValue;
            return false;
        }
        if (value > 500) {
            this.cockpit.materials.items.opacity = 0;
        }
    }

    setNames(value) {
        if (value <= 200) {
            this.cockpit.materials.title.opacity = 0;
            return false;
        }
        if (value <= 250) {
            let calculateValue = this.sliderToScale(value - 200, 50, 0, 1);
            this.cockpit.materials.title.opacity = calculateValue;
            return false;
        }
        if (value <= 300) {
            this.cockpit.materials.title.opacity = 1;
            return false;
        }
        if (value <= 350) {
            let calculateValue = 1 - this.sliderToScale(value - 300, 50, 0, 1);
            this.cockpit.materials.title.opacity = calculateValue;
            return false;
        }
        if (value > 350) {
            this.cockpit.materials.title.opacity = 0;
        }
    }
}
